const data = [
   {
      name: "did you having fun right now?",
      answers: [
         { text: "yes", index: 0 }, { text: "no", index: 1 }, { text: "maybe", index: 2 }, { text: "i don't know", index: 3 }
      ],
      right: 0
   },
   {
      name: "who is king david?",
      answers: [
         { text: "singer", index: 0 }, { text: "king from the bible", index: 1 }, { text: "cleaner on apple store", index: 2 }, { text: "prime minister", index: 3 }
      ],
      right: 1
   },
   {
      name: "how many mothers was on the bible?",
      answers: [
         { text: "1", index: 0 }, { text: "6", index: 1 }, { text: "3", index: 2 }, { text: "4", index: 3 }
      ],
      right: 3
   },
   {
      name: "What is the capital of Israel?",
      answers: [
         { text: "tel aviv", index: 0 }, { text: "monako", index: 1 }, { text: "jerusalem", index: 2 }, { text: "bee'r sheva", index: 3 }
      ],
      right: 2
   },
   {
      name: "In what year did World War II begin???",
      answers: [
         { text: "2002", index: 0 }, { text: "1994", index: 1 }, { text: "1939", index: 2 }, { text: "1936", index: 3 }
      ],
      right: 2
   },
]

export default data